import { AxiosInstance } from "axios"
import { DashboardUpdateCreatePayload } from "../types/macroApi"
import { Dashboard, DashboardData, DashboardLight } from "../views/pages/Dataviz/types/dashboard"

export interface IMacroApi {
  getDashboards: () => Promise<DashboardLight[]>
  getDashboardData: (dashboardId: number) => Promise<DashboardData>
  createDashboard: (data: DashboardUpdateCreatePayload) => Promise<Dashboard>
  updateDashboard: (dashboardId: number, data: DashboardUpdateCreatePayload) => Promise<Dashboard>
  runDashboardPrediction: (dashboardId: number) => Promise<{ status: string; freq: string }>
  deleteDashboard: (dashboardId: number) => Promise<void>
}

/**
 * Api routes for /api/v1/macro/
 */
const macroApi = (axiosClient: AxiosInstance): IMacroApi => ({
  getDashboards: async () => {
    const { data } = await axiosClient.get("macro/dashboards/list/")
    return data
  },
  getDashboardData: async (dashboardId: number) => {
    const { data } = await axiosClient.get(`/macro/dashboards/${dashboardId}/data/`)
    return data
  },
  createDashboard: async (dashboardData: DashboardUpdateCreatePayload) => {
    const { data } = await axiosClient.post("/macro/dashboards/", dashboardData)
    return data
  },
  updateDashboard: async (dashboardId: number, dashboardData: DashboardUpdateCreatePayload) => {
    const { data } = await axiosClient.patch(`/macro/dashboards/${dashboardId}/`, dashboardData)
    return data
  },
  runDashboardPrediction: async (
    dashboardId: number,
  ): Promise<{ status: string; freq: string }> => {
    const { data } = await axiosClient.post(`/macro/dashboards/${dashboardId}/predict/`)
    return data
  },
  deleteDashboard: async (dashboardId: number): Promise<void> => {
    await axiosClient.delete(`/macro/dashboards/${dashboardId}/delete/`)
  },
})

export default macroApi
